import { useRouter } from 'next/router'
import { Language } from 'types/language'
import styles from './Privacy.module.scss'

const Privacy = () => {
  // Next router
  const { locale: language } = useRouter()

  const renderDutch = () => {
    return (
      <div className={styles.privacy}>
        <h3>(A) GEBRUIKSVOORWAARDEN WEBSITE EN APPLICATIE BOLT ENERGIE</h3>
        <p>1. TOEPASSINGSGEBIED EN CONTACTGEGEVENS</p>
        <p>
          Deze Gebruiksvoorwaarden zijn van toepassing op uw gebruik van de websites uitgebaat door Bolt Energie (www.boltenergie.be)
          (hierna aangeduid als "Websites"); en de applicaties voor ondermeer het ingeven van meterstanden en eventueel aanpassen van
          voorschotbedragen van Bolt Energie (hierna aangeduid als "Applicatie").
        </p>
        <p>
          Alvorens, op eender welke wijze, gebruik te maken van de Websites of Applicatie, wordt u vriendelijk verzocht om deze (A)
          Gebruiksvoorwaarden, de (B) Privacyverklaring en de (C) Cookieverklaring aandachtig te lezen.
        </p>
        <p>
          Door uw bezoek aan de Websites of Applicatie, of door eender welk gebruik ervan, verklaart u zich uitdrukkelijk akkoord met de
          Gebruiksvoorwaarden, de Privacyverklaring en de Cookieverklaring. Indien u bij het lezen van de Gebruiksvoorwaarden, de
          Privacyverklaring en/of de Cookieverklaring niet akkoord gaat met de inhoud ervan, wordt u verzocht om geen verder gebruik te
          maken van de Websites of Applicatie.
        </p>
        <p>
          De Websites en Applicatie worden uitgebaat door Bolt Energie BV, een vennootschap naar Belgisch recht, met maatschappelijke zetel
          te 1210 Brussel, Sint-Lazaruslaan 4-10, en ingeschreven onder het ondernemingsnummer 0726.633.730 ("Bolt Energie").
        </p>
        <p>Voor verdere inlichtingen of opmerkingen kan u Bolt Energie contacteren op het volgende adres:</p>
        <p>
          Bolt Energie bv
          <br />
          Sint-Lazaruslaan 4-10
          <br />
          1210 Brussel
          <br />
          info@boltenergie.be
          <br />
        </p>
        <p>2. DOEL EN INHOUD VAN DE WEBSITES EN APPLICATIE</p>
        <p>
          De Websites en Applicatie verstrekken informatie en laten interactie toe met Bolt Energie over haar producten en diensten en laten
          toe om uw energiecontract te beheren.
        </p>
        <p>3. AARD VAN DE INFORMATIE</p>
        <p>
          De informatie die op de Websites en Applicatie wordt verstrekt is van algemene aard en de gebruiker kan geen rechten ontlenen aan
          deze informatie. Tenzij anders vermeld, vormt de informatie verstrekt op de Website en Applicatie op geen enkele manier een aanbod
          van diensten en/of producten.
        </p>
        <p>
          Bolt Energie levert grote inspanningen opdat de ter beschikking gestelde informatie volledig, juist, nauwkeurig en bijgewerkt zou
          zijn. Ondanks deze inspanningen, kunnen er zich onjuistheden voordoen in de ter beschikking gestelde informatie.
        </p>
        <p>4. AANSPRAKELIJKHEID</p>
        <p>
          Bolt Energie kan in geen geval of onder geen enkele omstandigheid, op directe of indirecte, algemene of bijzondere wijze
          aansprakelijk worden gesteld voor rechtstreekse of onrechtstreekse schade te wijten aan het gebruik van de Websites of Applicatie,
          inzonderheid als gevolg van links of hyperlinks, met inbegrip, zonder beperking, van het verstrekken van verkeerde informatie,
          alle verliezen, werkonderbrekingen, beschadiging van programma's of andere gegevens op het computersysteem, van apparatuur,
          programmatuur of andere van de gebruiker.
        </p>
        <p>
          Ondanks alle inspanningen, kunnen internetdiensten nooit volledig vrij zijn van mogelijke beveiligingsrisico's. Daarom is Bolt
          Energie niet verantwoordelijk voor schendingen van de confidentialiteit van gebruikersgegevens, bijvoorbeeld wanneer de Websites,
          de Applicatie of de servers van Bolt Energie worden aangevallen door derden.
        </p>
        <p>
          De inhoud van de Websites en de Applicatie kan te allen tijde zonder aankondiging of kennisgeving aangepast, gewijzigd of
          aangevuld worden. Bolt Energie geeft geen garanties voor de goede werking van de Websites en Applicatie en kan op geen enkele
          wijze aansprakelijk gehouden worden voor een slechte werking of tijdelijke (on)beschikbaarheid of voor enige vorm van schade,
          rechtstreekse of onrechtstreekse, die zou voortvloeien uit de toegang tot of het gebruik van de Websites of Applicatie.
        </p>
        <p>
          De Websites of de Applicatie kunnen hyperlinks bevatten naar websites of pagina's van derden of van partners, of daar
          onrechtstreeks naar verwijzen. Het plaatsen van links naar deze websites of pagina's impliceert op geen enkele wijze een
          impliciete goedkeuring door Bolt Energie van de inhoud ervan. Bolt Energie verklaart uitdrukkelijk dat zij geen zeggenschap heeft
          over de inhoud of over andere kenmerken van deze websites en kan in geen geval aansprakelijk gehouden worden voor de inhoud of de
          kenmerken ervan of voor enige andere vorm van schade door het gebruik ervan. Bolt Energie verwijst tevens naar de eigen
          gebruiksvoorwaarden van de betreffende websites.
        </p>
        <p>5. ACCOUNTS</p>
        <p>
          Accounts andere dan geregistreerd voor klanten van Bolt Energie en accounts die zijn aangemaakt op geautomatiseerde wijze zijn
          niet toegestaan. U mag de Websites of Applicatie niet gebruiken voor illegale of ongeoorloofde doeleinden. U bent verantwoordelijk
          voor alle handelingen die zich via uw account voordoen.
        </p>
        <p>
          Bolt Energie zal gerechtigd zijn om, zonder waarschuwing, uw account op te zeggen in het geval van niet-naleving van deze
          Gebruiksvoorwaarden, in het geval van schriftelijk of verbaal onaangepast of bedreigend gedrag tegenover Bolt Energie medewerkers
          of in het geval van enig misbruik van de Websites of Applicatie, inclusief misbruik voor reclamedoeleinden.
        </p>
        <p>6. TOEGANG TOT EN GEBRUIK VAN DE KLANTENZONE</p>
        <p>
          Bolt Energie kan niet aansprakelijk gesteld worden voor de gevolgen van het onrechtmatig en ongeoorloofd gebruik van de
          klantenzones via de Applicatie en/of de Websites door middel van het gebruik van uw gebruikersnaam en paswoord. De gebruiker is
          verantwoordelijk voor elk gebruik van de gebruikersnaam en paswoord. De gebruiker verbindt er zich toe om zijn gebruikersnaam en
          paswoord niet door te geven aan enige derde. Wanneer u anderen toch toegang wenst te geven tot de klantenzone van
          www.boltenergie.be (indien toepasselijk), kan u hiervoor uw Key Accountmanager contacteren. De toegang tot en het gebruik van de
          klantenzone door de door u aangevraagde gebruikers valt volledig buiten de verantwoordelijkheid van Bolt Energie.
        </p>
        <p>
          Indien u op een bepaald moment toegang zou hebben tot gegevens waarvan u vermoedt dat ze niet binnen uw gebruikersrechten horen,
          vragen wij u om dit onmiddellijk te melden aan Bolt Energie via de contact link. Bolt Energie zal alle redelijke inspanningen
          leveren om dergelijke problemen met de hoogst mogelijke dringendheid te behandelen.
        </p>
        <p>
          U gaat ermee akkoord om enkel van de klantenzone gebruik te maken op een wijze die in overeenstemming is met het toepasselijke
          recht of met de specifiek op u van toepassing zijnde wettelijke of andere regels. Bovendien gaat u ermee akkoord om op de
          klantenzone geen gebruik te maken van "deep links", "robots" of enige andere technologie waardoor de klantenzone of de inhoud
          ervan wordt aangewend voor een doeleinde andere dan degene die aangegeven is in deze Gebruikersvoorwaarden. U mag zich geen
          toegang verschaffen tot inhoud op de klantenzone die niet voor u bestemd is, bijvoorbeeld door "hacking", "password-mining", of
          door enige andere techniek. Verder gaat u akkoord om de eventuele kwetsbaarheid van de klantenzone niet te testen of beproeven. U
          gaat ermee akkoord om geen acties te ondernemen die een disproportioneel grote load op de klantenzone, het netwerk of de systemen
          van Bolt Energie veroorzaken teneinde een "Denial of Service" of een gelijkaardige aanval uit te lokken. U mag bovendien geen
          gebruik maken van enige technologie die de goede werking van de klantenzone in gevaar kan brengen.
        </p>
        <p>7. INTELLECTUELE EIGENDOM</p>
        <p>
          Elke reproductie, publieke mededeling of hergebruik van de Websites of Applicatie een deel daarvan, d.i. met inbegrip van - doch
          niet beperkt tot - de daarin vervatte tekst, afbeeldingen, codes, interface elementen, informatie, videobestanden en
          geluidsbestanden, op welke wijze dan ook, is verboden behoudens na uitdrukkelijke, schriftelijke en voorafgaande toestemming van
          Bolt Energie.
        </p>
        <p>8. WIJZIGINGEN</p>
        <p>
          Bolt Energie behoudt zich steeds het recht voor om deze Gebruiksvoorwaarden te wijzigen. Het is uw verantwoordelijkheid om zelf
          regelmatig de toepasselijke Gebruiksvoorwaarden door te nemen en de laatste versie hiervan in acht te nemen. Deze
          Gebruiksvoorwaarden werden het laatst gewijzigd en herzien op 1 augustus 2019.
        </p>
        <p>
          Nieuwe functionaliteiten van de Websites of Applicatie, die via updates worden beschikbaar gemaakt, worden automatisch onderworpen
          aan deze Gebruikersvoorwaarden.
        </p>
        <p>9. TOEPASSELIJK RECHT EN BEVOEGDE RECHTBANKEN</p>
        <p>
          Deze Gebruiksvoorwaarden zijn onderworpen aan het Belgisch recht en dienen als dusdanig te worden geïnterpreteerd. In geval van
          een geschil zijn enkel de rechtbanken van het arrondissement Brussel bevoegd.
        </p>
        <h3>(B) PRIVACYVERKLARING</h3>
        <p>1. TOEPASSINGSGEBIED</p>
        <p>
          Deze Privacyverklaring is van toepassing op het verzamelen, het gebruik, de verwerking en/of de overdracht van persoonsgegevens
          van klanten van Bolt Energie NV. Voor de toepassing van de deze Privacyverklaring betekent de verwijzing naar "Websites": de
          websites uitgebaat door Bolt Energie (waaronder onder meer www.boltenergie.be), en de verwijzing naar "Applicaties": de mobiele
          applicaties uitgebaat door Bolt Energie BV (waaronder onder meer de applicatie voor het ingeven van meterstanden en eventueel
          aanpassen van voorschotbedragen van Bolt Energie).
        </p>
        <p>
          Bolt Energie draagt zorg voor uw privacy en handelt hierbij steeds in overeenstemming met de bepalingen van de toepasselijke
          regelgeving inzake gegevensbescherming (de "Wetgeving Gegevensbescherming"), onder meer (i) tot 25 mei 2018: de Richtlijn
          Gegevensbescherming 95/46/EC zoals omgezet in de Wet van 8 december 1992 voor de bescherming van de persoonlijke levenssfeer ten
          opzichte van de verwerking van persoonsgegevens ("Privacywet") en (ii) vanaf 25 mei 2018, Verordening (EU) 2016/679 van het
          Europees Parlement en de Raad van 27 april 2016 betreffende de bescherming van natuurlijke personen in verband met de verwerking
          van persoonsgegevens en betreffende het vrije verkeer van die gegevens en tot intrekking van Richtlijn 95/46/EG ("algemene
          verordening gegevensbescherming" of "AVG"), alsook (iii) de praktijkcodes, gedragscodes, regelgevende initiatieven en
          standaardclausules, alsook gerelateerde regelgeving voortvloeiend uit dergelijke Richtlijn of Verordening, zoals op regelmatige
          basis herzien.
        </p>
        <p>
          Lees deze Privacyverklaring om meer te weten te komen over de wijze waarop uw persoonsgegevens worden verzameld, gebruikt en
          verwerkt onder de verantwoordelijkheid van Bolt Energie en desgevallend kunnen worden overgedragen aan derden.
        </p>
        <p>
          Door uw persoonsgegevens mee te delen aan ons erkent u op de hoogte te zijn gesteld van de hierna vermelde voorwaarden waaronder
          Bolt Energie persoonsgegevens verzamelt, gebruikt, verwerkt en doorgeeft.
        </p>
        <p>
          Indien u persoonsgegevens van andere personen meedeelt aan ons, maakt u zich sterk en garandeert u dat deze voorwaarden werden
          meegedeeld aan de betrokkene waarop de persoonsgegevens betrekking hebben en dat, in de mate dat bepaalde verwerkingen op
          toestemming berusten, u de relevante toestemming van de betrokkene aan deze verwerkingen door Bolt Energie hebt bekomen.
        </p>
        <p>
          Meer informatie over het gebruik van cookies vindt u onder punt (C) Cookieverklaring. De voorwaarden voor gebruik van de Websites
          en Applicaties vindt u onder punt (A) Gebruiksvoorwaarden.
        </p>
        <p>2. VERANTWOORDELIJKE VOOR DE VERWERKING</p>
        <p>De verwerkingsverantwoordelijke is:</p>
        <p>Bolt Energie BV (een vennootschap naar Belgisch recht)</p>
        <p>Maatschappelijke zetel: 1210 Brussel, Sint-Lazaruslaan 4-10</p>
        <p>Ondernemingsnummer 0726.633.730</p>
        <p>3. VERWERKING VAN PERSOONSGEGEVENS</p>
        <p>3.1. Verzameling, gebruik en andere verwerkingen van persoonsgegevens</p>
        <p>
          Bolt Energie verzamelt en verwerkt verschillende categorieën persoonsgegevens in verband met u (of de relevante betrokkene). Dit
          kan gebeuren in het kader van het aangaan van een overeenkomst, het surfen op onze Website of het gebruiken van onze verschillende
          Applicaties.
        </p>
        <p>
          <strong>Statistische informatie</strong> - Bij ieder bezoek aan de Websites of gebruik van de Applicaties kunnen verschillende
          persoonsgegevens en logbestanden automatisch over u worden verzameld, met name uw IP-adres, eventueel uw locatie, de datum en duur
          van uw bezoek aan de Websites of uw gebruik van de Applicaties, de websites van waaruit u naar de Websites wordt doorgelinkt, uw
          browser, uw besturingssysteem, uw surfgedrag op de Websites en in het bijzonder de pagina's die u op de Websites bezoekt. Deze
          gegevens worden uitsluitend gebruikt voor statistische doeleinden en om de werking en het gebruik van de Websites en de
          Applicaties te analyseren en te optimaliseren, conform het gerechtvaardigde belang van Bolt Energie om haar producten en diensten
          te verbeteren.
        </p>
        <p>
          <strong>Klantinformatie</strong> - Wanneer u op of via de Websites of Applicaties gebruik maakt van de aangeboden
          functionaliteiten, zoals (i) een vergelijking van energieprijzen vragen, (ii) een aanvraag doen van een Bolt Energie contract als
          klant of een offerte opvragen, (iii) een account aanmaken op de Websites of Applicaties, (iv) uw energieconsumptie of uw
          facturatie raadplegen, (v) Bolt Energie contacteren, (vi) deelnemen aan een wedstrijd, (vii) uw instellingen in de klantenzone
          wijzigen, (viii) een elektronische domiciliëring aanvragen, (ix) akkoord gaan met het ontvangen van periodieke mededelingen van
          Bolt Energie of (x) uw contactgegevens achterlaten, worden bovendien bijkomende persoonsgegevens gevraagd en/of verzameld.
        </p>
        <p>
          Bolt Energie kan dergelijke (bijkomende) persoonsgegevens ook verzamelen op andere wijzen dan via de Websites of de Applicaties
          (bv. via digitale of papieren (inschrijvings-)formulieren, via e-mail, fax, telefoon, SMS, sociale media, partners en derden,
          inclusief publieke bronnen, enz.).
        </p>
        <p>
          De persoonsgegevens die worden gevraagd en verzameld kunnen bijvoorbeeld volgende gegevens omvatten: uw naam, woonplaats,
          e-mailadres, telefoonnummer, taal, geslacht, energieconsumptie, rekeningnummer, klantenhistoriek en gezinssamenstelling. In het
          kader van klantenbeheer en dossieropvolging kan Bolt Energie, teneinde u sneller en efficiënter te kunnen helpen, ook uw locatie
          verwerken evenals verbruiksgegevens en metergegevens onder meer via smart metering toepassingen.
        </p>
        <p>Dergelijke persoonsgegevens kunnen worden gebruikt respectievelijk:</p>
        <ol>
          <li>
            om uw aanvraag voor een contract bij Bolt Energie te kunnen bevestigen, voor de aanmaak, aanvaarding en opvolging van uw
            klantendossier, om u de gevraagde producten of diensten te verstrekken en op te volgen, voor algemeen klantenbeheer, voor de
            dienst naverkoop en voor de invordering;
          </li>
          <li>
            om statistische informatie te verzamelen en trend analyses op te (laten) stellen voor financiële, beheers-, marketing- en
            rapporteringsdoeleinden;
          </li>
          <li>
            om een profiel van klanten en prospecten op te stellen (profilering), klantengegevens (en gegevens van prospecten) te
            centraliseren en te combineren en te verrijken met relevante gegevens om klanten (en prospecten) op een efficiënte en zo
            gepersonaliseerd mogelijke manier te kunnen bijstaan;
          </li>
          <li>
            om geautomatiseerde besluiten te nemen (op basis van criteria zoals regio, uw betaalgewoontes, de betaalgewoontes van
            gelijkaardige klanten, enz.) die rechtsgevolgen kunnen hebben voor u, zoals bijvoorbeeld teneinde u bepaalde opties voor
            betaling toe te staan of op te leggen;
          </li>
          <li>
            voor het bijhouden van de boekhouding, de bestrijding van fraude, misdrijven en inbreuken en het beheer van de betwistingen en
            eventuele juridische procedures;
          </li>
          <li>
            voor het verwerken van en/of de overdracht van uw gegevens in het kader van de overdracht van schuldvorderingen aan een derde;
          </li>
          <li>
            om uw vraag, mededeling of verzoek te kunnen behandelen en hierop desgevallend te antwoorden (bv. om u gevraagde informatie
            omtrent producten of diensten van Bolt Energie te verstrekken);
          </li>
          <li>om u te laten deelnemen aan een wedstrijd en u te informeren omtrent het verloop en de afloop daarvan;</li>
          <li>om u nieuwsbrieven en gepersonaliseerde marketing via e-mail of via andere kanalen te bezorgen.</li>
        </ol>
        <p>
          De verwerkingen voor de doeleinden vermeld onder punten (i), (iv), (v), (vi) en (viii) hierboven zijn noodzakelijk voor de
          totstandkoming of uitvoering van onze overeenkomst met u. Zonder deze persoonsgegevens kan de overeenkomst dus niet uitgevoerd
          worden.
        </p>
        <p>
          De verwerkingen voor de doeleinden vermeld onder punten (ii), (iii), (vii) en (ix) zijn noodzakelijk voor onze gerechtvaardigde
          belangen om onze producten en diensten te verbeteren en te promoten (in het bijzonder, het verschaffen van informatie betreffende
          gelijkaardige diensten en producten), alsook om een gepersonaliseerde ervaring aan onze klanten en prospecten te verzekeren. Onder
          gelijkaardige diensten en producten begrijpen wij alle diensten en producten die te maken hebben met energie en
          energie-efficiëntie.
        </p>
        <p>
          Voor zover wettelijk vereist, zullen bepaalde verwerkingen voor de doeleinden vermeld onder punt (ix) en, in bepaalde
          omstandigheden, punt (iv) op uw toestemming rusten.
        </p>
        <p>3.2. Doorgifte aan derde partijen</p>
        <p>
          Bolt Energie doet soms een beroep op derde-dienstverleners. Uw persoonsgegevens kunnen, indien noodzakelijk voor hun
          dienstverlening, ook aan deze derde-dienstverleners worden overgemaakt. In dat geval verwerken zij uw persoonsgegevens enkel
          conform de instructies van Bolt Energie.
        </p>
        <p>
          Bolt Energie kan hiernaast bepaalde persoonsgegevens ook doorgeven aan derden voor verwerkingen waarvan de doeleinden en middelen
          door deze derden worden bepaald. In dat geval treden deze derden op als verwerkingsverantwoordelijke onder de toepasselijke
          wetgeving inzake gegevensbescherming. Dit bevat de doorgifte:
        </p>
        <ol>
          <li>aan verbonden ondernemingen van Bolt Energie;</li>
          <li>op uw verzoek, aan externe commerciële partners van Bolt Energie, onder meer voor promotionele doeleinden;</li>
          <li>
            aan derden aan wie Bolt Energie schuldvorderingen, die zij heeft op klanten, overdraagt (met inbegrip van cessionarissen conform
            het toepasselijk wettelijk kader);
          </li>
          <li>
            aan bevoegde autoriteiten in het kader van dreigende of hangende juridische procedures, in het kader van gerechtelijke
            opsporingen en informatievragen, op vraag van de overheid of om andere wettelijke verplichtingen na te leven.
          </li>
        </ol>
        <p>
          Voor verdere informatie over deze verwerkingen, verwijst Bolt Energie dan ook naar het toepasselijke privacybeleid van deze
          derden.
        </p>
        <p>Deze doorgiftes zijn wel tevens gerechtvaardigd, en niet tegen betaling: uw persoonsgegevens verkopen wij niet.</p>
        <p>3.3. Doorgifte naar het buitenland</p>
        <p>
          Wij kunnen uw gegevens doorgeven naar derden in landen buiten de Europese Economische Ruimte. In dat geval waarborgen wij
          voorafgaand aan de doorgifte dat deze derden een passend niveau van gegevensbescherming hanteren (bv. door een eigen certificering
          van de ontvanger voor het EU-US-Privacy Shield, of door het opnemen van de zogenaamde EU modelcontractbepalingen van de Europese
          Unie in de overeenkomst met de ontvanger).
        </p>
        <p>
          Indien u meer informatie wenst over de maatregelen die werden toegepast, neem hiervoor contact op met ons via info@boltenergie.be
        </p>
        <p>4. UW RECHTEN</p>
        <p>
          <strong>Recht op inzage</strong> - U heeft een recht van inzage tot de persoonsgegevens die wij van u verwerken, alsook het recht
          een kopie van deze persoonsgegevens te verkrijgen (behoudens bepaalde uitzonderingen).
        </p>
        <p>
          <strong>Recht op gegevensoverdraagbaarheid</strong> - U heeft het recht op overdraagbaarheid van de door u verstrekte
          persoonsgegevens.
        </p>
        <p>
          <strong>Recht op verbetering en wissing</strong> - U heeft te allen tijde de mogelijkheid om uw gegevens door ons kosteloos te
          laten verbeteren of wissen, mits daarvoor aan de wettelijke bepalingen is voldaan. Uitgezonderd van het wissen zijn die gegevens
          die wij nodig hebben voor de uitvoering van nog lopende opdrachten of waarvan wij wettelijk verplicht zijn ze bij te houden.
        </p>
        <p>
          <strong>Beperking van de verwerking</strong> - U kan van ons, indien voldaan is aan de hiervoor geldende wettelijke bepalingen,
          verlangen dat wij de verwerking van uw gegevens beperken.
        </p>
        <p>
          <strong>Bezwaar</strong> - U mag bezwaar uitoefenen tegen onze verwerkingen voor reclamedoeleinden of verwerkingen die ons
          gerechtvaardigd belang als rechtsgrond hebben.
        </p>
        <p>
          <strong>Intrekking van uw toestemming</strong> - Indien wij uw persoonsgegevens verwerken op grond van uw toestemming, beschikt u
          over het recht om die toestemming op ieder moment te herroepen. Deze herroeping zal echter geen invloed hebben op de wettigheid
          van de verwerking van uw persoonsgegevens voor de periode die voorafgaat aan het moment van deze herroeping en op
          verwerkingsactiviteiten die berusten op een andere rechtsgrond.
        </p>
        <p>
          <strong>Klacht bij de bevoegde autoriteit</strong> - U heeft steeds het recht om contact op te nemen met de bevoegde autoriteit
          voor gegevensbescherming in België en in voorkomend geval klacht in te dienen.
        </p>
        <p>5. BEWARINGSDUUR VAN UW PERSOONSGEGEVENS</p>
        <p>
          Uw gegevens worden bijgehouden gedurende een periode van maximaal 10 jaar na beëindiging van uw laatst lopende contract bij Bolt
          Energie, behoudens wettelijke uitzonderingen. Daarna zullen de gegevens worden geanonimiseerd of verwijderd.
        </p>
        <p>6. WIJZIGINGEN</p>
        <p>
          Bolt Energie behoudt zich het recht voor om de Privacyverklaring steeds te wijzigen. Deze Privacyverklaring werd het laatst
          gewijzigd en herzien op 1 augustus 2019.
        </p>
        <p>7. CONTACTGEGEVENS VAN DE FUNCTIONARIS VOOR GEGEVENSBESCHERMING</p>
        <p>
          Voor informatie en suggesties over het thema gegevensbescherming staan wij, resp. onze functionaris voor gegevensbescherming, u op
          het e-mailadres: info@boltenergie.be graag ter beschikking.
        </p>
        <p>(C) COOKIEVERKLARING</p>
        <p>
          Deze Cookieverklaring is van toepassing op de websites uitgebaat door Bolt Energie (www.boltenergie.be, hierna aangeduid als
          "Websites").
        </p>
        <p>
          De Websites worden uitgebaat door Bolt Energie BV, een vennootschap naar Belgisch recht, met maatschappelijke zetel te 1080
          Brussel, Félix Delhassestraat 15, en ingeschreven onder het ondernemingsnummer 0726.633.730 ("Bolt Energie").
        </p>
        <p>Deze Cookieverklaring legt uit welke cookies worden gebruikt in de Websites.</p>
        <p>
          Het gebruik van cookies door Bolt Energie kadert binnen het algemene beleid van Bolt Energie met betrekking tot de bescherming van
          uw privacy en de verwerking van uw persoonsgegevens. Verdere informatie hierover vindt u onder punt (B) Privacyverklaring.
        </p>
        <p>De voorwaarden voor het gebruik van de Websites vindt u onder punt (A) Gebruiksvoorwaarden.</p>
        <p>1. WAT ZIJN COOKIES?</p>
        <p>
          "Cookies" zijn kleine informatiebestanden die door de server van een website via de browser tijdelijk of permanent op uw computer
          of toestel worden opgeslagen. De cookies bevatten een unieke code die toelaat om uw browser te herkennen tijdens uw bezoek aan die
          website (dit is een "session" cookie) of ook tijdens latere bezoeken of bij later gebruik (dit is een "permanent" cookie). Cookies
          laten toe het gebruik van een Website te vereenvoudigen, vervolledigen en personaliseren.
        </p>
        <p>
          Wij kunnen ook vergelijkbare tags en trackers gebruiken die op andere manieren de opslagcapaciteit van uw computer of toestel
          gebruiken. Voor het gemak wordt er hierin ook naar deze tags en trackers als "cookies" verwezen.
        </p>
        <p>2. GEBRUIK VAN COOKIES OP DE WEBSITES VAN BOLT ENERGIE</p>
        <p>De Websites van Bolt Energie gebruiken verschillende soorten cookies:</p>
        <p>2.1. Noodzakelijke cookies</p>
        <p>
          Deze cookies zijn onmisbaar om de Websites te kunnen bezoeken en om bepaalde onderdelen ervan te kunnen gebruiken. Deze cookies
          laten u bijvoorbeeld toe om te navigeren tussen de verschillende onderdelen van de Websites of om formulieren in te vullen. Ook
          wanneer u met uw gebruikersnaam wenst in te loggen op de klantenzone via de Websites zijn cookies noodzakelijk om op een veilige
          manier uw identiteit te controleren vooraleer we toegang geven tot uw persoonlijke informatie. Indien u deze cookies weigert
          zullen bepaalde onderdelen van de Websites niet werken.
        </p>
        <p>2.2. Performantiecookies</p>
        <p>
          Dit zijn cookies die tot doel hebben om informatie te verzamelen over de manier waarop bezoekers de Websites gebruiken, zoals
          informatie aangaande de bezochte pagina's of het aantal weergegeven foutmeldingen, teneinde de kwaliteit, het gebruik en het
          functioneren van de Websites te analyseren en te optimaliseren.
        </p>
        <p>2.3. Andere cookies</p>
        <p>
          Wanneer u de Websites bezoekt of gebruikt, kunnen er op uw computer of toestel cookies geïnstalleerd en gelezen worden door derde
          partijen zoals affiliates en adverteerders met wie Bolt Energie samenwerkt voor bv. de reclame op de Websites en andere websites
          in ons reclamenetwerk, of surfgedrag over verschillende websites heen. De reclame-gerelateerde cookies worden met name gebruikt om
          relevante en gepersonaliseerde advertenties te tonen (op basis van uw surfgedrag op de Websites en andere websites in ons
          reclamenetwerk), om het aantal keren dat iedere advertentie wordt getoond, te beperken of om de effectiviteit van een
          reclamecampagne te meten. Andere cookies kunnen ook worden gebruikt om statistieken op te stellen.
        </p>
        <p>3. BEHEER VAN COOKIES</p>
        <p>
          Voor het plaatsen van noodzakelijke cookies is uw toestemming niet vereist. Voor performantie en andere cookies vragen wij uw
          toestemming vooraleer deze te plaatsen. U kunt uw toestemming geven door verder op onze website te surfen of door op het relevante
          knop in de cookiebanner te klikken.
        </p>
        <p>
          U kunt ook op elk moment de reeds geïnstalleerde cookies verwijderen van uw computer of mobiel eindapparaat door uw
          browserinstellingen aan te passen. Let wel op dat door alle cookies te weigeren, u ook de noodzakelijke cookies zal weigeren en de
          functionaliteit van de websites zal beperken. Op de volgende website vindt u voor de meest gebruikte browsers de werkwijze om
          cookies te weigeren of te verwijderen: www.allaboutcookies.org.
        </p>
        <p>4. WIJZIGINGEN</p>
        <p>
          Bolt Energie behoudt zich steeds het recht voor om deze Cookieverklaring te wijzigen. Het is uw verantwoordelijkheid om zelf
          regelmatig de toepasselijke Cookieverklaring door te nemen en de laatste versie hiervan in acht te nemen. Deze Cookieverklaring
          werd het laatst gewijzigd en herzien op 1 augustus 2019.
        </p>
      </div>
    )
  }

  const renderFrench = () => {
    return (
      <div className={styles.privacy}>
        <h3>(A) CONDITIONS D'UTILISATION DES SITES INTERNET ET DES APPLICATIONS DE BOLT ENERGIE</h3>
        <p>1. DOMAINE D'APPLICATION ET COORDONNÉES</p>
        <p>
          Les présentes Conditions d'utilisation s'appliquent à votre utilisation : des sites Internet exploités par Bolt Energie (ci-après
          dénommés les " Sites internet "); et des applications permettant notamment la saisie des index et l'adaptation éventuelle des
          acomptes de Bolt Energie (ci-après dénommées les " Applications ").
        </p>
        <p>
          Avant d'utiliser les Sites Internet ou les Applications, de quelque façon que ce soit, veuillez lire attentivement les présentes
          (A) Conditions d'utilisation, la (B) Déclaration en matière de protection de la vie privée et la (C) Déclaration relative aux
          Cookies.
        </p>
        <p>
          Par votre visite des Sites Internet ou des Applications, ou par leur utilisation de quelque manière que soit, vous marquez
          expressément votre accord avec les Conditions d'utilisation, la Déclaration en matière de protection de la vie privée et la
          Déclaration relative aux Cookies. Si, à la lecture des Conditions d'utilisation, de la Déclaration en matière de protection de la
          vie privée et/ou de la Déclaration relative aux Cookies, vous êtes en désaccord avec leur contenu, veuillez ne plus faire usage
          des Sites Internet ni des Applications.
        </p>
        <p>
          Les Sites Internet et les Applications sont exploités par Bolt Energie, une société de droit belge dont le siège social est situé
          à 1210 Bruxelles, Boulevard Saint-Lazare 4-10, et inscrite sous le numéro d'entreprise 0726.633.730 (" Bolt Energie ").
        </p>
        <p>Pour plus d'informations ou pour toutes remarques, veuillez prendre contact avec Bolt Energie à l'adresse suivante:</p>
        <p>
          Bolt Energie SRL
          <br />
          Boulevard Saint-Lazare 4-10
          <br />
          1210 Bruxelles
          <br />
          info@boltenergie.be
          <br />
        </p>
        <p>2. OBJET ET CONTENU DES SITES INTERNET ET DES APPLICATIONS</p>
        <p>
          Les Sites Internet et les Applications fournissent des informations et permettent d'interagir avec Bolt Energie à propos de ses
          produits et services; ils vous donnent également la possibilité de gérer votre contrat d'énergie.
        </p>
        <p>3. NATURE DES INFORMATIONS PRÉSENTÉES</p>
        <p>
          Les informations présentées sur les Sites Internet et dans les Applications sont de nature générale et l'utilisateur ne peut tirer
          aucun droit de ces informations. Sauf mention contraire, les informations présentées sur les Sites Internet et les Applications ne
          constituent en aucun cas une offre de services et/ou de produits.
        </p>
        <p>
          Bolt Energie met tout en œuvre pour fournir des informations complètes, exactes, précises et à jour. En dépit de ces efforts, des
          erreurs peuvent néanmoins apparaître dans les informations présentées.
        </p>
        <p>4. RESPONSABILITÉ</p>
        <p>
          Bolt Energie ne peut en aucun cas ou en aucune circonstance, de façon directe ou indirecte, générale ou spécifique, être tenue
          pour responsable de dommages résultant directement ou indirectement de l'usage des Sites Internet ou des Applications, plus
          particulièrement suite à l'utilisation de liens ou d'hyperliens, y compris, sans limitation, la fourniture d'informations
          erronées, les pertes, les interruptions de travail, les dommages à des logiciels ou autres données sur le système informatique, au
          matériel, logiciel ou autre de l'utilisateur.
        </p>
        <p>
          Malgré tous les efforts déployés, les services sur Internet ne peuvent jamais être totalement exempts de risques de sécurité. Bolt
          Energie n'est dès lors pas responsable de la violation de la confidentialité des données d'utilisateurs, par exemple lorsque les
          Sites Internet, les Applications ou les serveurs de Bolt Energie font l'objet d'attaques de tiers.
        </p>
        <p>
          Le contenu des Sites Internet et des Applications peut à tout moment être adapté, modifié ou complété sans préavis ou
          notification. Bolt Energie ne donne aucune garantie quant au bon fonctionnement des Sites Internet et des Applications et ne peut
          en aucun cas être tenue pour responsable du mauvais fonctionnement ou de la disponibilité ou indisponibilité temporaire, ni
          d'aucun dommage, direct ou indirect, qui découlerait de l'accès aux Sites Internet et aux Applications ou de l'utilisation de
          ceux-ci.
        </p>
        <p>
          Les Sites Internet ou les Applications peuvent contenir des hyperliens vers d'autres sites ou pages de tiers ou de partenaires, ou
          y faire référence indirectement. La création de liens vers ces sites ou pages n'implique en aucune façon une approbation implicite
          de leur contenu par Bolt Energie. Bolt Energie déclare expressément n'avoir aucun contrôle sur le contenu ou d'autres
          caractéristiques de ces Sites Internet et ne peut en aucun cas être tenue pour responsable du contenu ni d'autres caractéristiques
          de ces Sites ni de toute autre forme de dommage résultant de leur utilisation. Bolt Energie renvoie également aux conditions
          d'utilisation des sites Internet concernés.
        </p>
        <p>5. COMPTES</p>
        <p>Les comptes non créés pour les clients de Bolt Energie et les comptes créés de façon automatisée ne sont pas autorisés.</p>
        <p>
          L'utilisation des Sites Internet et des Applications à des fins illégales ou illicites est interdite. Vous êtes responsable de
          toute activité réalisée par le biais de votre compte.
        </p>
        <p>
          Bolt Energie sera en droit de supprimer votre compte sans préavis en cas de non-respect des présentes Conditions d'utilisation, en
          cas de comportement écrit ou verbal inapproprié ou menaçant envers les employés de Bolt Energie ou de tout abus des Sites Internet
          ou des Applications, y compris à des fins publicitaires.
        </p>
        <p>6. ACCÈS ET UTILISATION DE L'ESPACE CLIENT</p>
        <p>
          Bolt Energie ne peut être tenue pour responsable des conséquences de l'utilisation illégale ou illicite de la zone client via les
          Applications et/ou les Sites Internet par le biais de vos nom d'utilisateur et mot de passe. L'utilisateur est responsable de
          toute utilisation du nom d'utilisateur et du mot de passe. L'utilisateur s'engage à ne pas transmettre son nom d'utilisateur ni
          son mot de passe à des tiers. Si vous souhaitez néanmoins donner à d'autres accès à la zone client de www.boltenergie.be (si
          d'application), veuillez prendre contact avec votre Key Account manager. L'accès à la zone client et son utilisation par les
          utilisateurs demandés par vous-même ne relèvent en aucune façon de la responsabilité de Bolt Energie.
        </p>
        <p>
          Si, à un moment donné, vous avez accès à des données dont vous soupçonnez qu'elles ne font pas partie de vos droits d'utilisation,
          nous vous demandons d'en aviser Bolt Energie immédiatement par le lien de contact. Bolt Energie fournira tous les efforts
          raisonnables pour traiter ces problèmes avec la plus grande urgence possible.
        </p>
        <p>
          Vous consentez à n'utiliser la zone client que d'une manière conforme au droit applicable ou aux règles légales ou autres qui
          s'appliquent spécifiquement à vous. Vous acceptez également de ne pas utiliser dans la zone client de " deep links ", " robots "
          ou toute autre technologie, par lesquels la zone client ou son contenu seraient utilisés à une fin autre que celle indiquée dans
          les présentes Conditions d'utilisation. Vous ne pouvez accéder au contenu de la zone client qui ne vous est pas destiné, par
          exemple via le " hacking ", le " password-mining " ou toute autre technique. Par ailleurs, vous consentez à ne pas tester ni
          éprouver l'éventuelle vulnérabilité de la zone client. Vous consentez à n'entreprendre aucune action qui causerait un chargement
          disproportionnellement grand dans la zone client, sur le réseau ou les systèmes de Bolt Energie dans le but de provoquer une
          attaque " Denial of Service " ou similaire. Vous ne pouvez en outre faire usage d'aucune technologie susceptible de compromettre
          le bon fonctionnement de la zone client.
        </p>
        <p>7. PROPRIÉTÉ INTELLECTUELLE</p>
        <p>
          Toute reproduction, communication publique ou réutilisation partielle ou entière des Sites Internet ou des Applications, y
          compris, sans limitation, les textes, illustrations, codes, éléments d'interface, informations, fichiers vidéo et audio, de
          quelque façon que ce soit, sont interdites sauf autorisation expresse, écrite et préalable de Bolt Energie.
        </p>
        <p>8. MODIFICATIONS</p>
        <p>
          Bolt Energie se réserve à tout moment le droit de modifier les présentes Conditions d'utilisation. Il est de votre responsabilité
          de parcourir régulièrement les présentes Conditions d'utilisation et de ne prendre en compte que la dernière version de celles-ci.
          Les présentes Conditions d'utilisation ont été revues et modifiées pour la dernière fois le 1 août 2019.
        </p>
        <p>
          Les nouvelles fonctionnalités des Sites Internet ou des Applications, disponibles par le biais de mises à jour, sont
          automatiquement soumises aux présentes Conditions d'utilisation.
        </p>
        <p>9. DROIT APPLICABLE ET TRIBUNAUX COMPÉTENTS</p>
        <p>Les présentes Conditions d'utilisation sont soumises au droit belge et doivent être interprétées conformément à ce droit.</p>
        <p>En cas de litige, seuls les tribunaux de l'arrondissement de Bruxelles sont compétents.</p>
        <h3>(B) DÉCLARATION EN MATIÈRE DE PROTECTION DE LA VIE PRIVÉE</h3>
        <p>1. DOMAINE D'APPLICATION</p>
        <p>
          La présente Déclaration en matière de protection de la vie privée s'applique à la collecte, à l'utilisation, au traitement et/ou à
          la transmission de données à caractère personnel de clients de Bolt Energie SRL.
        </p>
        <p>
          Pour l'application de la présente Déclaration en matière de protection de la vie privée, l'expression " Sites Internet " fait
          référence aux sites exploités par Bolt Energie et les " Applications " renvoient aux applications mobiles exploitées par Bolt
          Energie (notamment l'application permettant la saisie des index et l'adaptation éventuelle des acomptes de Bolt Energie).
        </p>
        <p>
          Bolt Energie protège votre vie privée et agit conformément aux dispositions de la réglementation en vigueur en matière de
          protection des données à caractère personnel (la " Législation relative à la protection des données à caractère personnel "),
          notamment (i) jusqu'au 25 mai 2018 : la Directive 95/46/CE relative à la protection de données à caractère personnel telle que
          transposée dans la Loi du 8 décembre 1992 relative à la protection de la vie privée à l'égard des traitements de données à
          caractère personnel (" Loi vie privée ") et (ii) à partir du 25 mai 2018, le Règlement (UE) 2016/679 du Parlement européen et du
          Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel
          et à la libre circulation de ces données et abrogeant la Directive 95/46/CE (" règlement général sur la protection des données "
          ou " RGPD "), ainsi que (iii) les codes de bonnes pratiques, les codes de conduite, les initiatives réglementaires et les clauses
          standard, de même que la réglementation afférente issue de ces Directive ou Règlement, telle que revue régulièrement.
        </p>
        <p>
          Lisez la présente Déclaration en matière de protection de la vie privée afin d'en apprendre davantage sur la façon dont vos
          données à caractère personnel sont collectées, utilisées et traitées sous la responsabilité de Bolt Energie, et dont elles
          peuvent, le cas échéant, être transmises à des tiers.
        </p>
        <p>
          En nous communiquant vos données à caractère personnel, vous reconnaissez être courant des conditions précisées ci-dessous
          auxquelles Bolt Energie collecte, utilise, traite et transmet les données à caractère personnel.
        </p>
        <p>
          Si vous nous transmettez des données à caractère personnel de tiers, vous vous portez fort et vous garantissez que ces conditions
          ont été communiquées à la personne concernée à laquelle les données ont trait et que, dans la mesure où certains traitements
          reposent sur une autorisation, vous avez obtenu de la personne concernée l'autorisation nécessaire à ces traitements par Bolt
          Energie.
        </p>
        <p>
          Vous trouverez plus d'informations sur l'utilisation des cookies au point (C) Déclaration relative au cookies. Les conditions
          d'utilisation des Sites Internet et des Applications se trouvent au point (A) Conditions d'utilisation.
        </p>
        <p>2. RESPONSABLE DU TRAITEMENT</p>
        <p>Le responsable du traitement est:</p>
        <p>Bolt Energie SRL (une société de droit belge)</p>
        <p>Siège social : 1210 Bruxelles, Boulevard Saint-Lazare 4-10</p>
        <p>Numéro d'entreprise 0726.633.730</p>
        <p>3. TRAITEMENT DES DONNÉES Á CARACTÈRE PERSONNEL</p>
        <p>3.1 Collecte, utilisation et autres traitements de données à caractère personnel</p>
        <p>
          Bolt Energie collecte et traite différentes catégories de données à caractère personnel vous concernant (ou relatives à la
          personne concernée). Cela peut se faire dans le cadre de la conclusion d'un contrat, de la visite de notre Site Internet ou de
          l'utilisation de nos diverses Applications.
        </p>
        <p>
          <strong>Informations statistiques</strong> - Lors de chaque visite des Sites Internet ou de l'utilisation des Applications, divers
          fichiers de journal et données à caractère personnel vous concernant peuvent être automatiquement collectés, notamment votre
          adresse IP, éventuellement votre localisation, la date et la durée de votre visite sur les Sites ou de votre utilisation des
          Applications, les sites à partir desquels vous avez été redirigé(e) vers les Sites Internet, votre navigateur, votre système
          d'exploitation, vos habitudes de navigation sur les Sites Internet et plus particulièrement les pages que vous visitez sur les
          Sites Internet. Ces informations sont uniquement utilisées à des fins statistiques et en vue d'analyser et d'optimiser le
          fonctionnement et l'utilisation des Sites Internet et des Applications, conformément à l'intérêt légitime de Bolt Energie
          d'améliorer ses produits et services.
        </p>
        <p>
          <strong>Informations client</strong> - Lorsque, sur ou via les Sites Internet ou les Applications, vous utilisez les
          fonctionnalités offertes, telles que (i) une demande de comparaison des prix de l'énergie, (ii) une demande de contrat Bolt
          Energie en tant que client ou une demande d'offre, (iii) la création d'un compte sur les Sites Internet ou les Applications, (iv)
          la consultation de votre consommation d'énergie ou de votre facture, (v) une prise de contact avec Bolt Energie, (vi) la
          participation à un concours, (vii) une modification de vos préférences dans la zone client, (viii) une demande de domiciliation
          électronique, (ix) votre accord quant à la réception de communications périodiques de Bolt Energie, ou (x) la communication de vos
          coordonnées, des données à caractère personnel complémentaires sont demandées et/ou collectées.
        </p>
        <p>
          Bolt Energie peut également collecter ces données à caractère personnel (supplémentaires) autrement que par l'intermédiaire des
          Sites Internet ou des Applications (p. ex. par le biais de formulaires (d'inscription) en version numérique ou papier, de
          courriels, de fax, par téléphone, SMS, médias sociaux, partenaires et tiers, y compris les sources publiques, etc.).
        </p>
        <p>
          Les données à caractère personnel demandées et collectées peuvent inclure par exemple les informations suivantes : vos nom,
          domicile, adresse électronique, numéro de téléphone, langue, sexe, consommation d'énergie, numéro de compte, historique client et
          composition de ménage. Dans le cadre de la gestion clients et du suivi des dossiers et afin de vous offrir un service plus rapide
          et plus efficace, Bolt Energie peut aussi traiter votre localisation ainsi que vos données de consommation et vos index, notamment
          via des applications smart metering.
        </p>
        <p>Ces données à caractère personnel peuvent être utilisées respectivement :</p>
        <ol>
          <li>
            pour confirmer votre demande de contrat auprès de Bolt Energie, pour la création, l'acceptation et le suivi de votre dossier
            client, afin de vous fournir les produits ou services demandés et d'en assurer le suivi, pour la gestion générale de la
            clientèle, le service après-vente et le recouvrement;
          </li>
          <li>
            pour rassembler des données statistiques et (faire) établir des analyses tendancielles à des fins financières, de gestion, de
            marketing et de reporting;
          </li>
          <li>
            pour établir un profil de clients et prospects (profilage), centraliser, combiner et enrichir les données clients (et de
            prospects) à l'aide d'informations utiles afin d'offrir aux clients (et prospects) une assistance aussi efficace et
            personnalisée que possible;
          </li>
          <li>
            pour prendre de façon automatisée des décisions (sur la base de critères tels que la région, vos habitudes de paiement, les
            habitudes de paiement de clients similaires, etc.) susceptibles d'avoir des effets sur vous, p. ex. afin de vous accorder ou de
            vous imposer certaines options de paiement;
          </li>
          <li>
            pour tenir la comptabilité, lutter contre la fraude, les délits et les infractions et assurer la gestion des litiges et des
            procédures juridiques éventuelles;
          </li>
          <li>pour traiter et/ou transmettre vos données dans le cadre de la cession de créances à un tiers;</li>
          <li>
            pour traiter vos questions, communications ou demandes et y répondre (p. ex. afin de vous fournir les informations demandées
            concernant des produits ou services de Bolt Energie);
          </li>
          <li>pour vous permettre de participer à un concours et vous informer quant à son déroulement et son issue;</li>
          <li>pour vous envoyer des bulletins d'information et du marketing personnalisé par voie électronique ou par d'autres canaux.</li>
        </ol>
        <p>
          Les traitements aux fins précisées aux points (i), (iv), (v), (vi) et (viii) ci-dessus sont nécessaires à la réalisation ou à la
          mise en œuvre de notre convention avec vous. Sans ces données à caractère personnel, la convention ne peut donc pas être mise en
          œuvre.
        </p>
        <p>
          Les traitements aux fins précisées aux points (ii), (iii), (vii) et (ix) sont nécessaires à nos intérêts légitimes d'améliorer et
          de promouvoir nos produits et services (en particulier la communication d'informations relatives à des produits et services
          similaires), et d'assurer à nos clients et prospects une expérience personnalisée. Par produits et services similaires, nous
          entendons tous les produits et services relatifs à l'énergie et à l'efficacité énergétique.
        </p>
        <p>
          Dans la mesure où la loi l'exige, certains traitements aux fins précisées au point (ix) et, dans certaines circonstances, au point
          (iv), seront sujets à une autorisation de votre part.
        </p>
        <p>3.2 Transfert à des tiers</p>
        <p>
          Bolt Energie fait parfois appel à des fournisseurs tiers. Vos données à caractère personnel peuvent également, si nécessaire à
          leur prestation de service, être transférées à ces tiers. Dans ce cas, le traitement sera effectué uniquement conformément aux
          instructions de Bolt Energie.
        </p>
        <p>
          Bolt Energie peut également transférer certaines données à caractère personnel à des tiers pour des traitements dont les objectifs
          et moyens sont définis par lesdits tiers. Dans ce cas, ces tiers sont responsables du traitement aux termes de la législation
          applicable en matière de protection des données à caractère personnel. Il s'agit notamment de la transmission :
        </p>
        <ol>
          <li>à des entreprises liées à Bolt Energie;</li>
          <li>
            à des tiers auxquels Bolt Energie cède des créances sur des clients (y compris les cessionnaires conformément au cadre légal en
            vigueur) ;
          </li>
          <li>
            aux autorités compétentes dans le cadre de procédures juridiques imminentes ou en cours, dans le cadre de recherches judiciaires
            et de demandes d'information, à la demande des autorités ou afin de se conformer à d'autres obligations légales.
          </li>
        </ol>
        <p>
          Pour plus d'informations sur ces traitements, Bolt Energie renvoie dès lors à la politique de protection de la vie privée de ces
          tiers.
        </p>
        <p>Ces transferts d'informations sont légitimes et gratuits : nous ne vendons pas vos données à caractère personnel.</p>
        <p>3.3 Transfert à l'étranger</p>
        <p>
          Nous pouvons transférer vos données vers des pays en dehors de l'Espace économique européen. Dans ce cas, nous garantissons,
          préalablement au transfert, que ces tiers respectent un niveau adéquat de protection des données à caractère personnel (p.ex. via
          une auto-certification du destinataire au Bouclier de Protection des Données UE - Etats-Unis, ou par l'intégration des clauses
          contractuelles types UE de l'Union européenne dans le contrat avec le destinataire).
        </p>
        <p>Pour plus d'informations sur les mesures mises en œuvre, veuillez prendre contact avec nous via info@boltenergie.be</p>
        <p>4. VOS DROITS</p>
        <p>
          <strong>Droit de regard</strong> - Vous disposez d'un droit de regard sur vos données à caractère personnel que nous traitons, et
          vous avez le droit d'obtenir une copie de ces données à caractère personnel (à certaines exceptions près).
        </p>
        <p>
          <strong>Droit à la portabilité des données</strong> - Vous avez droit à la portabilité des données à caractère personnel que vous
          communiquez.
        </p>
        <p>
          <strong>Droit de corriger et d'effacer des données</strong> - Vous avez à tout moment la possibilité de nous demander de corriger
          ou d'effacer gratuitement vos données, pour autant qu'il soit satisfait aux dispositions légales en la matière. Ne peuvent être
          effacées, les données dont nous avons besoin pour la réalisation des marchés toujours en cours ou que nous sommes légalement
          obligés de conserver.
        </p>
        <p>
          <strong>Limitation du traitement :</strong> Vous pouvez, s'il est satisfait aux dispositions légales en vigueur en la matière,
          nous demander de limiter le traitement de vos données.
        </p>
        <p>
          <strong>Opposition</strong> - Vous pouvez vous opposer à nos traitements à des fins publicitaires ou aux traitements juridiquement
          basés sur notre intérêt légitime.
        </p>
        <p>
          <strong>Retrait de votre autorisation</strong> - Si nous traitons vos données à caractère personnel sur la base de votre
          autorisation, vous disposez du droit de révoquer cette autorisation à tout moment. Cette révocation n'aura cependant aucun impact
          sur la légalité du traitement de vos données à caractère personnel pour la période précédant le moment de ladite révocation, ni
          sur les activités de traitement reposant sur une autre base juridique.
        </p>
        <p>
          <strong>Plainte auprès de l'autorité compétente</strong> - Vous avez toujours le droit de prendre contact avec l'autorité
          compétente en matière de protection des données à caractère personnel en Belgique et, le cas échéant, de déposer une plainte.
        </p>
        <p>Pour exercer les droits précités, vous pouvez utiliser le formulaire qui se trouve ici à partir du 1 août 2019.</p>
        <p>5. DURÉE DE CONSERVATION DE VOS DONNÉES Á CARACTÈRE PERSONNEL</p>
        <p>
          Vous données sont conservées pendant une période d'au maximum 10 ans après la fin de votre dernier contrat en cours auprès de Bolt
          Energie, sauf exceptions légales. Passé ce délai, les données sont anonymisées ou supprimées.
        </p>
        <p>6. MODIFICATIONS</p>
        <p>
          Bolt Energie se réserve le droit de modifier à tout moment la Déclaration en matière de protection de la vie privée. La présente
          Déclaration en matière de protection de la vie privée a été revue et modifiée pour la dernière fois le 1 août 2019.
        </p>
        <p>7. COORDONNÉES DU RESPONSABLE DE LA PROTECTION DES DONNÉES Á CARACTÈRE PERSONNEL</p>
        <p>
          Pour toutes informations et suggestions sur le thème de la protection des données à caractère personnel, notre responsable de la
          protection des données à caractère personnel est à votre disposition à l'adresse suivante : info@boltenergie.be.
        </p>
        <h3>(C) DÉCLARATION RELATIVE AUX COOKIES</h3>
        <p>
          La présente Déclaration relative aux Cookies s'applique aux sites Internet sites exploités par Bolt Energie (ci-après dénommés les
          " Sites Internet ").
        </p>
        <p>
          Les Sites Internet sont exploités par Bolt Energie SRL, une société de droit belge dont le siège social est situé à 1210
          Bruxelles, Boulevard Saint-Lazare 4-10, et inscrite sous le numéro d'entreprise 0726.633.730 (" Bolt Energie ").
        </p>
        <p>La présente Déclaration relative aux Cookies explique quels cookies sont utilisés sur les Sites Internet.</p>
        <p>
          L'utilisation de cookies par Bolt Energie s'inscrit dans le cadre de la politique générale de Bolt Energie relative à la
          protection de votre vie privée et du traitement de vos données à caractère personnel. Vous trouverez plus d'informations à ce
          sujet sous le point (B) Déclaration en matière de protection de la vie privée.
        </p>
        <p>Vous trouverez les conditions d'utilisation des Sites Internet sous le point (A) Conditions d'utilisation.</p>
        <p>1. QUE SONT LES COOKIES ?</p>
        <p>
          Les " cookies " sont de petits fichiers informatiques qui sont sauvegardés de façon temporaire ou permanente par le serveur d'un
          site Internet, par le biais de votre navigateur, sur votre ordinateur ou appareil. Les cookies contiennent un code unique qui
          permet de reconnaître votre navigateur lors de votre visite sur ce site Internet (cookie de " session ") ou lors de visites
          ultérieures (cookie " permanent "). Les cookies permettent de simplifier, de compléter et de personnaliser l'utilisation d'un Site
          Internet.
        </p>
        <p>
          Nous pouvons également faire appel à des " tags " et " trackers " analogues qui utilisent autrement la capacité de stockage de
          votre ordinateur ou appareil. Pour plus de facilité, ces tags et trackers sont également appelés " cookies " dans le présent
          document.
        </p>
        <p>2. UTILISATION DE COOKIES SUR LES SITES INTERNET DE BOLT ENERGIE</p>
        <p>Les Sites Internet de Bolt Energie recourent à divers types de cookies :</p>
        <p>2.1 Cookies nécessaires</p>
        <p>
          Ces cookies sont indispensables à la visite des Sites Internet et à l'utilisation de certaines parties de ceux-ci. Ils vous
          permettent par exemple de naviguer entre les différentes parties des Sites Internet ou de remplir des formulaires. Lorsque vous
          souhaitez vous connecter à la zone client à l'aide de votre nom d'utilisateur, les cookies sont nécessaires au contrôle sécurisé
          de votre identité, préalable à l'autorisation de l'accès à vos informations personnelles. Si vous refusez ces cookies, certaines
          parties des Sites Internet ne fonctionneront pas.
        </p>
        <p>2.2 Cookies de performance</p>
        <p>
          Ce sont les cookies destinés à rassembler des informations sur la façon dont les visiteurs utilisent les Sites Internet, comme les
          informations sur les pages visitées ou le nombre de messages d'erreur affichés, afin d'analyser et d'optimiser la qualité,
          l'utilisation et le fonctionnement des Sites Internet.
        </p>
        <p>2.3 Autres cookies</p>
        <p>
          Lorsque vous visitez ou utilisez les Sites Internet, des cookies peuvent être installés sur votre ordinateur ou votre appareil et
          lus par des tiers tels que des affiliés et des annonceurs avec lesquels Bolt Energie travaille pour, p. ex. analyser l'affichage
          de publicités sur les Sites Internet et sur d'autres sites de notre réseau publicitaire, ou analyser les habitudes de navigation
          sur différents sites Internet. Les cookies publicitaires sont notamment utilisés pour l'affichage de publicités personnalisées (en
          fonction de vos habitudes de navigation sur les Sites Internet et sur d'autres sites de notre réseau publicitaire), la limitation
          du nombre de fois qu'une publicité est affichée, ou la mesure de l'efficacité d'une campagne publicitaire. D'autres cookies
          peuvent aussi être utilisés pour établir des statistiques.
        </p>
        <p>3. GESTION DES COOKIES</p>
        <p>
          Votre autorisation n'est pas requise pour l'installation des cookies nécessaires. Pour les cookies de performance et les autres
          cookies, nous vous demandons votre autorisation avant de les installer. Vous pouvez donner votre autorisation en continuant de
          visiter notre site Internet ou en cliquant sur le bouton adéquat dans la bannière de cookies.
        </p>
        <p>
          Vous pouvez également supprimer à tout moment les cookies de votre ordinateur ou mobile en modifiant les paramètres de votre
          navigateur. Attention : en refusant tous les cookies, vous allez aussi refuser les cookies nécessaires et limiter la
          fonctionnalité des sites Internet. Vous trouverez sur le site Internet ci-après la façon de refuser ou de supprimer les cookies
          pour les navigateurs les plus courants : www.allaboutcookies.org.
        </p>
        <p>4. MODIFICATIONS</p>
        <p>
          Bolt Energie se réserve le droit de modifier à tout moment la présente Déclaration relative aux Cookies. Il est de votre
          responsabilité de parcourir régulièrement cette Déclaration relative aux Cookies et de ne prendre en compte que la dernière
          version de celle-ci. La présente Déclaration relative aux Cookies a été revue et modifiée pour la dernière fois le 1 août 2019.
        </p>
      </div>
    )
  }

  return (
    <>
      {language === Language.DUTCH && renderDutch()}
      {language === Language.FRENCH && renderFrench()}
    </>
  )
}

export default Privacy
